import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import CloseIcon from '@material-ui/icons/Close';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import React, { useMemo } from 'react';

import { ReactComponent as LogoIcon } from '@/assets/icons/logo.svg';
import { ReactComponent as LogoutIcon } from '@/assets/icons/logout.svg';
import { Func } from '@/utils/ts';

const useStyles = makeStyles(() => ({
  button: {
    cursor: 'pointer',
  },
}));

export enum TitleButtonType {
  LOGO = 'LOGO',
  BACK = 'BACK',
  CLOSE = 'CLOSE',
  LOGOUT = 'LOGOUT',
}

export type TitleButtonProp =
  | { type: TitleButtonType; onClick: Func; 'data-test'?: string }
  | React.FC<{ className: string; 'data-test'?: string }>;

export interface TitleButtonProps {
  'data-test'?: string;
  type: TitleButtonProp;
  className?: string;
}

const TitleButton: React.FC<TitleButtonProps> = ({ type, className: extraClassName, 'data-test': dataTest }) => {
  const classes = useStyles();
  const className = useMemo(() => clsx(classes.button, extraClassName), [classes.button, extraClassName]);
  if (typeof type === 'function') {
    return type({ className, 'data-test': dataTest });
  }
  switch (type.type) {
    case TitleButtonType.CLOSE:
      return <CloseIcon onClick={type.onClick} className={className} data-test={dataTest} />;
    case TitleButtonType.LOGO:
      return <LogoIcon onClick={type.onClick} className={className} data-test={dataTest} />;
    case TitleButtonType.LOGOUT:
      return <LogoutIcon onClick={type.onClick} className={className} data-test={dataTest} />;
    case TitleButtonType.BACK:
    default:
      return <ArrowBackIcon onClick={type.onClick} className={className} data-test="test" />;
  }
};

export default TitleButton;
